import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { CurrentUser, LoginRes, VerifyTokenRes, MerchantData, RegisterTokenRes } from './types'

export const selectEvent = (state: RootState): Event => state.userReducer.event

export const selectCurrentUser = (state: RootState): CurrentUser => state.userReducer.currentUser

export const selectLoginData = (state: RootState): LoginRes | undefined => state.userReducer.loginData

export const selectVerifyTokenData = (state: RootState): VerifyTokenRes | undefined =>
  state.userReducer.verifyTokenData

export const selectMyMerchantsEvent = (state: RootState): Event => state.userReducer.myMerchantsevent

export const selectMyMerchants = (state: RootState): MerchantData[] => state.userReducer.myMerchants

export const selectRegisterTokenData = (state: RootState): RegisterTokenRes | undefined =>
  state.userReducer.registerTokenData

export const selectStaffPermissionEvent = (state: RootState): Event => state.userReducer.staffPermissionEvent
